const CaseTypes = {
  DOWNLOAD_DOCUMENT: "DOWNLOAD_DOCUMENT",
  DELETE_DOCUMENT_AFFAIRE: "DELETE_DOCUMENT_AFFAIRE",
  DELETE_DOCUMENT_AFFAIRE_SUCCESS: "DELETE_DOCUMENT_AFFAIRE_SUCCESS",
  POST_CASE: "POST_CASE",
  ADD_AND_SEND_CONTRACT_FOR_SIGNATURE: "ADD_AND_SEND_CONTRACT_FOR_SIGNATURE",
  // Affaires
  POST_AFFAIRE: "POST_AFFAIRE",
  POST_AFFAIRE_SUCCESS: "POST_AFFAIRE_SUCCESS",
  PATCH_AFFAIRE: "PATCH_AFFAIRE",
  PATCH_AFFAIRE_SUCCESS: "PATCH_AFFAIRE_SUCCESS",
  GET_AFFAIRES: "GET_AFFAIRES",
  GET_AFFAIRES_SUCCESS: "GET_AFFAIRES_SUCCESS",
  GET_AFFAIRE_BY_ID: "GET_AFFAIRE_BY_ID",
  GET_AFFAIRE_BY_ID_SUCCESS: "GET_AFFAIRE_BY_ID_SUCCESS",
  PATCH_DATA_AFFAIRE: "PATCH_DATA_AFFAIRE",
  PATCH_DATA_AFFAIRE_SUCCESS: "PATCH_DATA_AFFAIRE_SUCCESS",
  GET_LINE_NAME_BY_CODE: "GET_LINE_NAME_BY_CODE",
  GET_LINE_NAME_BY_CODE_SUCCESS: "GET_LINE_NAME_BY_CODE_SUCCESS",
  CLEAR_LINE_NAME: "CLEAR_LINE_NAME",
  GET_NUMBER_OF_AFFAIRES_CREATED_THIS_YEAR: "GET_NUMBER_OF_AFFAIRES_CREATED_THIS_YEAR",
  GET_NUMBER_OF_AFFAIRES_CREATED_THIS_YEAR_SUCCESS: "GET_NUMBER_OF_AFFAIRES_CREATED_THIS_YEAR_SUCCESS",
  EXPORT_DOCUMENTS_ZIP: "EXPORT_DOCUMENTS_ZIP",
  EXPORT_EXCEL: "MSF_EXPORT_EXCEL",
  // Works planning
  GET_WORKS_PLANNING: "GET_WORKS_PLANNING",
  GET_WORKS_PLANNING_SUCCESS: "GET_WORKS_PLANNING_SUCCESS",
  POST_WORKS_PLANNING: "POST_WORKS_PLANNING",
  POST_WORKS_PLANNING_SUCCESS: "POST_WORKS_PLANNING_SUCCESS",
  PATCH_WORKS_PLANNING: "PATCH_WORKS_PLANNING",
  PATCH_WORKS_PLANNING_SUCCESS: "PATCH_WORKS_PLANNING_SUCCESS",
  DELETE_WORKS_PLANNING: "DELETE_WORKS_PLANNING",
  DELETE_WORKS_PLANNING_SUCCESS: "DELETE_WORKS_PLANNING_SUCCESS",
  VALIDATE_WORKS_PLANNING: "VALIDATE_WORKS_PLANNING",
  VALIDATE_WORKS_PLANNING_SUCCESS: "VALIDATE_WORKS_PLANNING_SUCCESS",
  // Capacites
  GET_CAPACITES: "GET_CAPACITES",
  GET_CAPACITES_SUCCESS: "GET_CAPACITES_SUCCESS",
  POST_CAPACITES: "POST_CAPACITES",
  PATCH_CAPACITES: "PATCH_CAPACITES",
  DELETE_CAPACITES: "DELETE_CAPACITES",
  // Models
  GET_MODELS: "GET_MODELS",
  GET_MODELS_BY_TYPE: "GET_MODELS_BY_TYPE",
  GET_MODELS_SUCCESS: "GET_MODELS_SUCCESS",
  POST_MODEL: "POST_MODEL",
  POST_MODEL_SUCCESS: "POST_MODEL_SUCCESS",
  DELETE_MODEL: "DELETE_MODEL",
  DELETE_MODEL_SUCCESS: "DELETE_MODEL_SUCCESS",
  // Mails
  MSF_SEND_EMAIL: "MSF_SEND_MAIL",
  MSF_SEND_EMAIL_SUCCESS: "MSF_SEND_MAIL_SUCCESS",
}

export default CaseTypes
